<div class="engagement-gauge-container" #container>
  <div class="gauge-wrapper" [ngClass]="{'expanded': isExpanded}">
    <!-- Latest Entry -->
    <div *ngIf="!isExpanded" class="gauge-item gauge-item-clickable" (click)="toggleExpanded()" role="button"
      tabindex="0">
      <!-- Gauge Circle -->
      <div [ngClass]="latestClass" [matTooltip]="latestTooltip" matTooltipPosition="above" matTooltipShowDelay="500">
        <span class="material-icons gauge-icon">{{ latestIcon }}</span>
      </div>
      <!-- Today Label (When Expanded) -->
      <p class="day-label" *ngIf="isExpanded">Today</p>
    </div>
    <div>
      <!-- Toggle Button (When Expanded)
      <div *ngIf="isExpanded" class="gauge-item gauge-item-clickable d-none d-md-flex" style="padding-top: 8px;"
        (click)="toggleExpanded()" role="button" tabindex="0">
        <div class="gauge-toggle-button" matTooltip="{{ 'engagementgauge.collapse' | trans }}"
          matTooltipPosition="above" matTooltipShowDelay="500">
          <span class="material-icons gauge-icon" style="margin-right:-10px; font-size: 15px;">arrow_forward_ios</span>
        </div>
      </div> -->

      <!-- Full History (Expandable - Positioned) -->
      <div *ngIf="isExpanded && gaugeIcons.length > 1" (click)="toggleExpanded()" class="gauge-history">
        <div *ngFor="let icon of gaugeIcons; let i = index; trackBy: trackByIndex"
          class="gauge-item gauge-history-item"
          [ngClass]="{
            'd-none': i < gaugeIcons.length - 3,
            'd-md-flex': i >= gaugeIcons.length - 5,
            'd-xl-flex': true
          }">
          <!-- Gauge Circle -->
          <div [ngClass]="gaugeClasses[i]" [matTooltip]="tooltips[i]" matTooltipPosition="above"
            matTooltipShowDelay="500">
            <span class="material-icons gauge-icon">{{ icon }}</span>
          </div>
          <!-- Day Label -->
          <p class="day-label">{{ dayLabels[i] }}</p>
        </div>
      </div>
    </div>
  </div>
</div>